/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLayoutHeaderCards = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 2v20h20V2zm2 2h16v1.999h-5L13 6l-5-.001H4zm11 8.999h4.999v-5H15zm-7 0L13 13l-.001-5.001H8zm-4-5h2V20H4zm11 12h4.999v-5H15zm-7 0L13 20l-.001-5.001H8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLayoutHeaderCards as LayoutHeaderCards };
